const TRANSACTION_URL = `${process.env.API_V4_HOST}/mitra-payment/transactions`;

export const getTransactionHistory = ($axios, { trxType, apiVersion }) => {
  const params = new URLSearchParams();

  params.append('trx_type', trxType);
  if (apiVersion) {
    params.append('v', apiVersion);
  }
  return $axios.$get(`${TRANSACTION_URL}?${params.toString()}`);
};
